import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { CTAButton } from './CTAButton';
import { OFFER_ITEMS } from '../data/landing';
export function OfferSection() {
  return <section id="purchase" className="bg-cream py-14 md:py-20" aria-labelledby="offer-title" data-id="element-115" data-mp="8mdmtdf3lj45">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-116" data-mp="dfq412hg6nmv">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-117" data-mp="idrifa3xhys0">
          <Eyebrow data-id="element-118" data-mp="ifayp0pl49ts">La oferta</Eyebrow>
          <h2 id="offer-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-119" data-mp="meaczbx7hixw">
            Todo lo que recibes
          </h2>
        </div>

        <div className="mx-auto mt-8 max-w-[420px] rounded-[14px] border border-line bg-cream-soft p-5 md:p-6" data-id="element-120" data-mp="wdj3tvwryhg1">
          <ul className="divide-y divide-line/70" data-id="element-121" data-mp="2t6b6kfzxjvl0">
            {OFFER_ITEMS.map(item => <li key={item.label} className="flex items-start justify-between gap-3 py-2.5" data-id="element-122" data-mp="2y3kufr7o7z6q">
                <span className="flex items-start gap-2 text-[12px] font-medium text-ink md:text-[13px]" data-id="element-123" data-mp="12otijpklxrmp">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 flex-none text-gold" aria-hidden="true" data-id="element-124" data-mp="xup82wc4v1gv" />
                  {item.label}
                </span>
                <span className="flex-none text-[11px] font-bold text-ink-muted" data-id="element-125" data-mp="1lme52pzwge45">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 rounded-[12px] bg-cream-2 px-4 py-5 text-center" data-id="element-126" data-mp="1gl6vcle754uu">
            <p className="text-[12px] font-medium text-ink-muted line-through" data-id="element-127" data-mp="1ck4vq3gdaqsc">
              US$49
            </p>
            <p className="mt-0.5 text-[34px] font-extrabold leading-none tracking-[-0.03em] text-ink md:text-[40px]" data-id="element-128" data-mp="17opi9cm9uwwg">
              US$19
            </p>
            <p className="mt-2 text-[9px] font-bold uppercase tracking-[0.14em] text-ink-muted" data-id="element-129" data-mp="3sckjyxhy3uvm">
              Pago único · Acceso de por vida
            </p>
          </div>

          <div className="mt-5" data-id="element-130" data-mp="2ng6rzukx6bn">
            <CTAButton label="Quiero generar más atracción" data-id="element-131" data-mp="2mdi7ykqbfyw" />
          </div>
          <p className="mt-3 text-center text-[10px] font-medium text-ink-muted" data-id="element-132" data-mp="3ktung6k8fudq">
            Garantía de 7 días · Pago seguro · Acceso inmediato
          </p>
          <p className="mt-1.5 flex items-center justify-center gap-1.5 text-center text-[10px] font-medium text-ink-muted/80" data-id="element-133" data-mp="3owzijo1zgtsc">
            <GlobeIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-134" data-mp="3ftyj267mi0xn" />
            En el checkout verás el valor en la moneda de tu país.
          </p>
        </div>
      </div>
    </section>;
}